import { PackageActionTypes, PackageActions } from "../../actionTypes/master/packageTypes";


export const getPackageTypeNameAsValueDropdownList = (payload: any): PackageActionTypes => ({
  type: PackageActions.GET_PACKAGE_TYPE_NAME_AS_VALUE_DROPDOWN_LIST,
  payload
});

export const setPackageTypeNameAsValueDropdownList = (payload: any): PackageActionTypes => ({
  type: PackageActions.SET_PACKAGE_TYPE_NAME_AS_VALUE_DROPDOWN_LIST,
  payload
})

export const setPackageTypeNameAsValueDropdownLoading = (payload: any): PackageActionTypes => ({
  type: PackageActions.SET_PACKAGE_TYPE_NAME_AS_VALUE_DROPDOWN_LOADING,
  payload
})